module.exports = vendor;


//////////////////
// WEBPACK FOOTER
// external "vendor"
// module id = 7
// module chunks = 1